import { ApiCall, type ApiCallOptions } from './api.base';
import type {
  BinarizeImageRequest,
  BinarizeImageResponse,
  OutlineVectorizeResponse,
  OutlineVectorizeRequest,
  GenerateCutlineRequest,
  GenerateCutlineResponse,
  TrimImageWithSizeLimitRequest,
  TrimImageWithSizeLimitResponse,
  ApplyOffsetFromSvgResponse,
  ApplyOffsetFromSvgRequest,
} from '@modules/Vector/S/api.dto';

export class VectorApiCall extends ApiCall {
  constructor(options: ApiCallOptions = {}) {
    super(options);
  }

  async trimImageWithSizeLimit(
    body: TrimImageWithSizeLimitRequest,
    shouldAbortPrevious?: boolean,
    headers?: Record<string, string>,
  ): Promise<TrimImageWithSizeLimitResponse> {
    return this.post<TrimImageWithSizeLimitResponse>(
      '/:lang/@api/vector/image/trimWithSizeLimit', // app/all/api/vector.ts
      body,
      shouldAbortPrevious,
      headers,
    );
  }

  async binarizeImage(
    body: BinarizeImageRequest,
    shouldAbortPrevious?: boolean,
    headers?: Record<string, string>,
  ): Promise<BinarizeImageResponse> {
    return this.post<BinarizeImageResponse>(
      '/:lang/@api/vector/outline/image-binarization', // app/all/api/vector.ts
      body,
      shouldAbortPrevious,
      headers,
    );
  }

  async vectorizeOutline(
    body: OutlineVectorizeRequest,
    shouldAbortPrevious?: boolean,
    headers?: Record<string, string>,
  ): Promise<OutlineVectorizeResponse> {
    return this.post<OutlineVectorizeResponse>(
      '/:lang/@api/vector/outline/vectorize', // app/all/api/vector.ts
      body,
      shouldAbortPrevious,
      headers,
    );
  }

  async generateCutline(
    body: GenerateCutlineRequest,
    shouldAbortPrevious?: boolean,
    headers?: Record<string, string>,
  ): Promise<GenerateCutlineResponse> {
    return this.post<GenerateCutlineResponse>(
      '/:lang/@api/vector/cutline', // app/all/api/vector.ts
      body,
      shouldAbortPrevious,
      headers,
    );
  }

  async applyOffsetFromSvg(
    body: ApplyOffsetFromSvgRequest,
    shouldAbortPrevious?: boolean,
    headers?: Record<string, string>,
  ): Promise<ApplyOffsetFromSvgResponse> {
    return this.post<ApplyOffsetFromSvgResponse>(
      '/:lang/@api/vector/offset', // app/all/api/vector.ts
      body,
      shouldAbortPrevious,
      headers,
    );
  }
}
